import { Formik } from "formik";
import { TextInput } from "../../../../components/TextInput";
import { FormHeader } from "../FormHeader";
import { Loading } from "../../../../components/Loading";

const CreateForm = ({ children, formDefs = [], onSubmit, initialValues, showHeader = true, description = "" }) => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                await onSubmit(values);
                setSubmitting(false);
            }}
            enableReinitialize
        >
            {({ handleSubmit, handleChange, values, isSubmitting }) => (
                <form className="section-login__form-wrap" onSubmit={handleSubmit}>
                    {showHeader && <FormHeader />}
                    <div className="section-login__input-form">
                        {description && <div className="section-login__desc">{description}</div>}
                        {formDefs?.length > 0 &&
                            formDefs?.map((formInput) => {
                                return (
                                    <TextInput
                                        key={formInput?.name}
                                        type={formInput?.type}
                                        label={formInput?.label}
                                        name={formInput?.name}
                                        value={values[formInput?.name]}
                                        required={formInput?.required}
                                        onChange={handleChange}
                                        hint={formInput?.hint}
                                    />
                                );
                            })}
                    </div>
                    {children}
                    {isSubmitting && <Loading />}
                </form>
            )}
        </Formik>
    );
};

export default CreateForm;
